module.exports = __webpack_public_path__ + "static/img/V-M30_ar@2x.621d24bc.png";